"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentProps = exports.subComponentPropsOf = exports.sharedPropsOf = exports.componentPropsOf = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
require("@/components/common");
require("@/components/domains/component/component-prop-item");
const component_styles_1 = require("@/components/domains/component/component.styles");
const component_manifest_1 = require("@/generated/component-manifest");
const utils_1 = require("@/utils");
/**
 * 컴포넌트 선언(@property)에서 만든 prop 목록. 이름·타입·기본값을 문서에 손으로 옮겨 적지 않는다.
 * 선언이 바뀌면 npm run manifest로 다시 만든다. 이벤트·slot은 선언에서 읽을 수 없어 페이지가 덧붙인다.
 */
const componentPropsOf = (tag) => component_manifest_1.componentManifest[tag];
exports.componentPropsOf = componentPropsOf;
/** 계열이 함께 물려받는 prop(모든 태그에 같은 이름으로 있는 prop). 공통 prop을 한 번만 적을 때 쓴다. */
const sharedPropsOf = (...tags) => component_manifest_1.componentManifest[tags[0]].filter(prop => tags.every(tag => component_manifest_1.componentManifest[tag].some(({ name }) => name === prop.name)));
exports.sharedPropsOf = sharedPropsOf;
/**
 * 부모 페이지에 함께 전시하는 sub-component의 prop. 이름 앞에 태그를 붙여 어느 요소의 prop인지 가른다.
 * written에 이미 적은 prop(sharedPropsOf 결과 등)을 주면 같은 이름은 빼고 그 태그가 더하는 것만 남긴다.
 */
const subComponentPropsOf = (tag, written = []) => component_manifest_1.componentManifest[tag]
    .filter(prop => !written.some(({ name }) => name === prop.name))
    .map(prop => ({ ...prop, name: `${tag} ${prop.name}` }));
exports.subComponentPropsOf = subComponentPropsOf;
// 이보다 적은 prop은 접어도 가릴 내용이 없어 처음부터 펼쳐 둔다.
const COLLAPSIBLE_PROP_COUNT = 3;
/**
 * 컴포넌트 prop 목록. 전체 레이아웃 외곽 틀을 책임지고
 * 각 prop은 mm-component-prop-item으로 렌더합니다.
 * 접힌 상태에서 아무 곳이나 누르면 펼쳐지며, 펼침 여부는 open으로 드러납니다.
 * prop이 3개 미만이면 처음부터 펼쳐져 더보기 버튼을 노출하지 않습니다.
 */
let ComponentProps = class ComponentProps extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.props = [];
        this.open = false;
        this.propsId = (0, utils_1.uniqueId)('component-props');
    }
    willUpdate(changed) {
        if (!changed.has('props'))
            return;
        this.open = this.props.length < COLLAPSIBLE_PROP_COUNT;
    }
    /* eslint-disable lit-a11y/click-events-have-key-events -- 키보드로 펼치는 경로는 안쪽
       mm-read-more-button이 갖고, 그 click이 올라와 이 핸들러에 닿는다. section의 click은
       포인터 전용 단축이라 section 자체를 포커스 대상으로 만들지 않는다. */
    render() {
        return (0, lit_1.html) `
      <section class="component-props component-content-frame" @click=${this.handleClick}>
        <div hidden><mm-text as="h2">Props</mm-text></div>
        <div class="component-props-list" id=${this.propsId}>
          ${this.props.map(prop => this.renderPropItem(prop))}
        </div>
        <div class="component-props-more" aria-hidden=${this.open}>
          <mm-read-more-button
            more-label="...펼쳐서 더보기"
            aria-controls=${this.propsId}
            aria-expanded=${this.open}
          ></mm-read-more-button>
        </div>
      </section>
    `;
    }
    renderPropItem(prop) {
        return (0, lit_1.html) `
      <mm-component-prop-item
        name=${prop.name}
        type=${prop.type}
        kind=${(0, if_defined_js_1.ifDefined)(prop.kind)}
        ?optional=${prop.optional}
      ></mm-component-prop-item>
    `;
    }
    /* eslint-enable lit-a11y/click-events-have-key-events */
    handleClick() {
        this.open = true;
    }
};
ComponentProps.styles = component_styles_1.componentPropsStyles;
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], ComponentProps.prototype, "props", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], ComponentProps.prototype, "open", void 0);
ComponentProps = __decorate([
    (0, decorators_js_1.customElement)('mm-component-props')
], ComponentProps);
exports.ComponentProps = ComponentProps;
//# sourceMappingURL=data:application/json;base64,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